import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppConfig } from '@app/config/app.config';
import { AuthGuardService } from '@app/core/auth/auth-guard.service';
import { SigningComponent } from '@app/certificates/signing/component/signing.component';
import { BusinessComponent } from './business.component';
import { BusinessSigningComponent } from './business-signing/business-signing.component';
import { BusinessProfileComponent } from './business-profile/business-profile.component';
import { BusinessHistoryComponent } from './business-history/business-history.component';
import { BusinessReportsComponent } from './business-reports/business-reports.component';
import { IdentificationComponent } from './identification/identification.component';
import { BusinessSigningOtcComponent } from './business-signing-otc/business-signing-otc.component';
import { BusinessHardwareCertificatesComponent } from './business-hardware-certificates/business-hardware-certificates.component';
import { ManagmentHardwareCertificatesComponent } from './business-hardware-certificates/managment-hardware-certificates/managment-hardware-certificates.component';
import { CertificateHistoryComponent } from './business-hardware-certificates/certificate-history/certificate-history.component';

const routes: Routes = [
  {
    path: '',
    component: BusinessComponent,
    children: [
      {
        path: '',
        redirectTo: AppConfig.routes.business.sign,
        pathMatch: 'full'
      },
      {
        path: AppConfig.routes.business.profile,
        component: BusinessProfileComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.profile
        }
      },
      {
        path: AppConfig.routes.business.sign,
        component: BusinessSigningComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.sign
        }
      },
      {
        path: AppConfig.routes.business.history,
        component: BusinessHistoryComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.history
        }
      },
      {
        path: AppConfig.routes.business.reports,
        component: BusinessReportsComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.business.reports
        }
      },
      {
        path: AppConfig.routes.business.identification,
        component: IdentificationComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.business.identification
        }
      },
      {
        path: AppConfig.routes.business.signingotc,
        component: BusinessSigningOtcComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.business.signingotc
        }
      },
      {
        path: AppConfig.routes.business.hardwareCertificates,
        component: BusinessHardwareCertificatesComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.hardwareCertificates
        }
      },
      {
        path: AppConfig.routes.business.certificateHistory,
        component: CertificateHistoryComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.certificateHistory
        }
      },
      {
        path: AppConfig.routes.business.menageHardwareCertificates,
        component: ManagmentHardwareCertificatesComponent,
        canActivate: [AuthGuardService],
        data: {
          title: AppConfig.routes.certificates.menageHardwareCertificates
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessRoutingModule { }
